export const search = {
  inputs: [
    // ---------- 筛选区第1行
    {
      type: 'InputText',
      title: 'Customer Key',
      span: 6,
      placeholder: 'Customer Name Keyword',
      getter: 'state/search/baseCsr/name',
      setter: 'commit/search/setBaseCsrName',
      width: 200
    },
    {
      type: 'InputDateRangePicker',
      title: 'Create Date',
      span: 6,
      getter: 'state/search/baseCsr/createDateRange',
      setter: 'commit/search/setBaseCsrCreateRange'
    },
    {
      type: 'InputDateRangePicker',
      title: 'Modify Date',
      span: 6,
      getter: 'state/search/baseCsr/modifyDateRange',
      setter: 'commit/search/setBaseCsrModifyRange'
    },
    {
      type: 'InputSelect',
      title: 'Xero Sent',
      span: 6,
      options: 'getters/search/xeroSends',
      getter: 'state/search/baseCsr/xeroSend',
      setter: 'commit/search/setBaseCsrXeroSend',
      defaultValue: 0
    },
    // ---------- 筛选区第2行
    {
      type: 'InputSelect',
      title: 'Price Type',
      span: 6,
      options: 'getters/baseinfo/csrPriceStrategies',
      getter: 'state/search/baseCsr/priceType',
      setter: 'commit/search/setBaseCsrPriceType',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Business Type',
      span: 6,
      options: 'getters/baseinfo/csrBusinessTypes',
      getter: 'state/search/baseCsr/businessType',
      setter: 'commit/search/setBaseCsrBusinessType',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Payment Type',
      span: 6,
      options: 'getters/baseinfo/csrPaymentTypes',
      getter: 'state/search/baseCsr/paymentType',
      setter: 'commit/search/setBaseCsrPaymentType',
      defaultValue: 'All'
    },
    {
      type: 'InputSelect',
      title: 'Area Type',
      span: 6,
      options: 'getters/baseinfo/csrAreaTypes',
      getter: 'state/search/baseCsr/areaType',
      setter: 'commit/search/setBaseCsrAreaType',
      defaultValue: 0
    }
  ],
  lines: [
    {
      prop: 'name',
      label: 'Contact Name',
      width: 250
    },
    {
      prop: 'code',
      label: 'ABN No.',
      width: 120
    },
    {
      prop: 'creditLimit',
      label: 'Credit Limit',
      width: 96,
      align: 'right'
    },
    {
      prop: 'priceType',
      label: 'Price Type',
      width: 100
    },
    {
      prop: 'businessType',
      label: 'Business Type',
      width: 130
    },
    {
      prop: 'paymentType',
      label: 'Payment Type',
      width: 125
    },
    {
      prop: 'areaType',
      label: 'Area Type',
      width: 125
    },
    {
      prop: 'csrLevel',
      label: 'CSR Level',
      width: 88
    },
    {
      prop: 'csrService',
      label: 'Service Staff',
      width: 100
    },
    {
      prop: 'csrBD',
      label: 'Business Staff',
      width: 110
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 110
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 110
    },
    {
      prop: 'xeroSent',
      label: 'XeroSent',
      width: 77
    },
    {
      prop: 'ColumnViewBaseinfoBtn',
      label: 'Action'
    }
  ]
}

const add = {
  inputs: [
    {
      type: 'InputText',
      title: 'Contact Name',
      span: 12,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/name',
      setter: 'commit/baseinfo/setCsrName',
      width: 600,
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Login SHOP',
      span: 6,
      options: 'state/baseinfo/boolSelect',
      getter: 'state/baseinfo/customer/loginShop',
      setter: 'commit/baseinfo/setCsrLoginShop',
      defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'Email(Login ID)',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/email',
      setter: 'commit/baseinfo/setCsrEmail',
      width: 200
    },
    {
      type: 'InputText',
      title: 'ABN No.',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/code',
      setter: 'commit/baseinfo/setCsrContactId',
      width: 200,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Origin Code',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/origin_code',
      setter: 'commit/baseinfo/setCsrOriginCode',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Remark/Attention',
      span: 12,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/attention',
      setter: 'commit/baseinfo/setCsrAttention',
      width: 600
    },
    {
      type: 'InputText',
      title: 'Primary First Name',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/primary_person_first',
      setter: 'commit/baseinfo/setCsrFirstName',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Primary Last Name',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/primary_person_last',
      setter: 'commit/baseinfo/setCsrLastName',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Phone',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/phone',
      setter: 'commit/baseinfo/setCsrPhone',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Mobile',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/mobile',
      setter: 'commit/baseinfo/setCsrMobile',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Skype Name/Number',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/skype',
      setter: 'commit/baseinfo/setCsrSkype',
      width: 200
    },
    {
      type: 'InputDatePicker',
      title: 'Birthday',
      span: 6,
      getter: 'state/baseinfo/customer/birthday',
      setter: 'commit/baseinfo/setCsrBirthday',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Notes',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/note',
      setter: 'commit/baseinfo/setCsrNote',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Website',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/website',
      setter: 'commit/baseinfo/setCsrWebSite',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Full Address',
      span: 12,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/address',
      setter: 'commit/baseinfo/setCsrAddress',
      width: 600,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'City/Town',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/city',
      setter: 'commit/baseinfo/setCsrCity',
      width: 200
    },
    {
      type: 'InputText',
      title: 'State/Region',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/state',
      setter: 'commit/baseinfo/setCsrState',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Postal/Zip Code',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/postal',
      setter: 'commit/baseinfo/setCsrZip',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Country',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/country',
      setter: 'commit/baseinfo/setCsrCountry',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Account No.',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/account',
      setter: 'commit/baseinfo/setCsrAccount',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Credit limit',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/credit_limit',
      setter: 'commit/baseinfo/setCsrCreditLimit',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Also Supplier?',
      span: 6,
      options: 'state/baseinfo/boolSelect',
      getter: 'state/baseinfo/customer/is_supplier',
      setter: 'commit/baseinfo/setCsrIsSupplier',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Is Branch?',
      span: 6,
      options: 'state/baseinfo/boolSelect',
      getter: 'state/baseinfo/customer/branch_flag',
      setter: 'commit/baseinfo/setCsrBranch',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Price Strategy',
      span: 6,
      options: 'state/baseinfo/priceStrategy',
      getter: 'state/baseinfo/customer/price_strategy',
      setter: 'commit/baseinfo/setCsrPriceStrategy',
      defaultValue: '',
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Payment Type',
      span: 6,
      options: 'state/baseinfo/paymentType',
      getter: 'state/baseinfo/customer/payment_type',
      setter: 'commit/baseinfo/setCsrPayment',
      defaultValue: '',
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Area Type',
      span: 6,
      options: 'getters/baseinfo/areaTypes',
      getter: 'state/baseinfo/customer/area_type',
      setter: 'commit/baseinfo/setCsrArea',
      defaultValue: '',
      isRequire: true
    },
    // {
    //   type: 'InputText',
    //   title: 'Area Type',
    //   span: 6,
    //   placeholder: 'Please enter',
    //   getter: 'state/baseinfo/customer/area_type',
    //   setter: 'commit/baseinfo/setCsrArea',
    //   width: 200
    // },
    {
      type: 'InputText',
      title: 'Csr Level',
      span: 6,
      placeholder: 'Please enter',
      getter: 'state/baseinfo/customer/csr_level',
      setter: 'commit/baseinfo/setCsrLevel',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Business Type',
      span: 6,
      options: 'state/baseinfo/businessType',
      getter: 'state/baseinfo/customer/business_type',
      setter: 'commit/baseinfo/setCsrBusiness',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Default Ship Type',
      span: 6,
      options: 'state/baseinfo/shipType',
      getter: 'state/baseinfo/customer/default_ship_type',
      setter: 'commit/baseinfo/setCsrShipType',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Service Staff',
      span: 6,
      options: 'getters/sales',
      getter: 'state/baseinfo/customer/cs_id',
      setter: 'commit/baseinfo/setCsrCs',
      defaultValue: ''
    },
    {
      type: 'InputSelect',
      title: 'Business Staff',
      span: 6,
      options: 'getters/bd',
      getter: 'state/baseinfo/customer/bd_id',
      setter: 'commit/baseinfo/setCsrBd',
      defaultValue: ''
    }
  ]
}

const edit = {}
edit.inputs = add.inputs.slice()
edit.inputs[0] = {
  type: 'InputText',
  title: 'Contact Name',
  span: 12,
  placeholder: 'Please enter',
  getter: 'state/baseinfo/customer/name',
  setter: 'commit/baseinfo/setCsrName',
  width: 600,
  disabled: true,
  isRequire: true
}

edit.inputs[3] = {
  type: 'InputText',
  title: 'ABN No.',
  span: 6,
  placeholder: 'Please enter',
  getter: 'state/baseinfo/customer/code',
  setter: 'commit/baseinfo/setCsrContactId',
  width: 200,
  isRequire: true,
  disabled: true
}

edit.inputs[5] = {
  type: 'InputText',
  title: 'Remark/Attention',
  span: 12,
  placeholder: 'Please enter',
  getter: 'state/baseinfo/customer/attention',
  setter: 'commit/baseinfo/setCsrAttention',
  width: 600,
  disabled: !(Number.parseInt(localStorage.getItem('role')) === 4)
}

edit.inputs[20] = {
  type: 'InputText',
  title: 'Credit limit',
  span: 6,
  placeholder: 'Please enter',
  getter: 'state/baseinfo/customer/credit_limit',
  setter: 'commit/baseinfo/setCsrCreditLimit',
  width: 200,
  disabled: !(Number.parseInt(localStorage.getItem('role')) === 4)
}

export default { search, add, edit }
